"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentHTML = exports.Container = void 0;
var React = require("react");
var styled_components_1 = require("styled-components");
exports.Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var Content = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-top: 20px;\n  img, video {\n    width: 100%;\n    height: 100%;\n  }\n  table {\n    width: 100%;\n  }\n  a {\n    color: #005964;\n  }\n"], ["\n  margin-top: 20px;\n  img, video {\n    width: 100%;\n    height: 100%;\n  }\n  table {\n    width: 100%;\n  }\n  a {\n    color: #005964;\n  }\n"])));
exports.ContentHTML = styled_components_1.default(function (_a) {
    var children = _a.children;
    if (children) {
        return React.createElement(Content, { id: "content", dangerouslySetInnerHTML: { __html: children.toString() } });
    }
    return null;
})({});
var templateObject_1, templateObject_2;
